import React from 'react';
import { Container } from '@chakra-ui/react';
import ListingsTable from './components/ListingsTable';

const Listings = () => {
  return (
    <Container maxW="container.2xl" py={8} mt="50px">
      <ListingsTable />
    </Container>
  );
};

export default Listings;
